var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center"},[_vm._t("name"),_c('div',{staticClass:"flex items-center"},[_vm._t("metric"),_vm._t("icon")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }